import Route from '@ember/routing/route'
import { task, timeout } from 'ember-concurrency'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import { service } from '@ember/service'
import type ContentfulClient from 'teacher-ui-client/services/contentful-client'
import type { Params } from 'teacher-ui-client/subscription-type/lessons/route'

export default class MathseedsLessonsRoute extends Route {
  @service contentfulClient!: ContentfulClient

  model() {
    const lessonsParams = this.paramsFor('subscription-type.lessons') as Params
    const { perPage, pageNumber, searchQuery } = lessonsParams

    return {
      loaderInstance: this.fetchEntries.perform({ pageNumber, perPage, searchQuery }),
    }
  }

  fetchEntries = task(
    { restartable: true },
    async ({ pageNumber, perPage, searchQuery }: { pageNumber: number; perPage: number; searchQuery?: string }) => {
      await timeout(500)
      const lessonsData = await this.contentfulClient.getPrecinctLessonsData(Precinct.MS_LESSONS, {
        pageNumber,
        perPage,
        searchQuery,
      })
      const { previewByLessonDataId, resourcesByLessonDataId } =
        await this.contentfulClient.getLessonsDataRelatedEntries(lessonsData)

      const pageCount = Math.ceil(lessonsData.total / perPage)

      return { lessonsData, previewByLessonDataId, resourcesByLessonDataId, pageCount }
    },
  )
}
